<template>
  <div>
    <br />
    <br />
    <br />
    <div class="columns is-mobile">
      <div class="column is-half is-offset-one-quarter">
        <center>
          <h1 class="title" style="color:#004771">Claims Reporting</h1>

          <div class="card">
            <div class="card-content">
              <b>
                Report of Injury / Illness successfully submitted!
                <router-link
                  :to="{ name: 'review', params: { id : this.$route.params.id } }"
                >Click here&nbsp;</router-link>to view and print your submission!
              </b>
            </div>
            <br />Reported Claim Number:
            <b>{{this.$route.params.id}}</b>
            <br />
            <br />
          </div>
          <br />
        </center>
        <center>
          If you need further assistance contact your claims representative during business hours
          <br />24/7 Call Center at 888-336-7569
          <br />Claims email:
          <a href="mailto:riclaims@ri-net.com">riclaims@ri-net.com</a>
          <br />Claims fax: 818-789-7286
        </center>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

